import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerAddress } from 'src/app/models/customer-address';
import { AppConfigService } from 'src/app/services/app-config.service';
import { CurrentOrderService } from 'src/app/services/current-order.service';
import { CustomerAddressService } from 'src/app/services/customer-address.service';
import { CustomerService } from 'src/app/services/customer.service';
import { InitializationService } from 'src/app/services/initialization.service';
import { LocaleService } from 'src/app/services/locale.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { AlertDialogComponent } from '../dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-adress-picker',
  templateUrl: './adress-picker.component.html',
  styleUrls: ['./adress-picker.component.scss']
})
export class AdressPickerComponent implements OnInit 
{
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) 
  {
    $event.returnValue =true;
  }

  adressList:Array<CustomerAddress> = [];
  isLoading=false;
  showDelete=false;
  origin="";

  constructor(
    private initializationservice:InitializationService, 
    private navigationservice:NavigationService,
    private route: ActivatedRoute,
    private customerservice : CustomerService,
    public alertDialog: MatDialog,
    private router: Router,
    private currentorderservice: CurrentOrderService,
    private localeservice: LocaleService
  ) { }

  ngOnInit(): void 
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
    {
      this.initializationservice.reloadApp(appname);

      return;
    }

    this.origin = String(this.route.snapshot.queryParamMap.get('origin'));

    this.adressList = this.customerservice.getCustomerAdressList();
  }

  back()
  {
    this.navigationservice.back();
  }
  
  addAdress()
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(this.origin === 'profile')
      this.router.navigateByUrl('/' + appname + '/addresssearch?afterto=return');

    if(this.origin === 'orderresume')
      this.router.navigateByUrl('/' + appname + '/addresssearch?afterto=returnandset', { replaceUrl:true });

    if(this.origin === 'order')
      this.router.navigateByUrl('/' + appname + '/addresssearch?afterto=orderbasedata');
  }

  adressTap(adress:CustomerAddress)
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(this.origin === 'orderresume')
    {
      this.currentorderservice.setAdress(adress);

      this.back();
    }

    if(this.origin === 'order')
    {
      this.currentorderservice.setAdress(adress);

      this.router.navigateByUrl('/' + appname + '/orderbasedata');
    }

    if(this.origin === 'profile')
      this.removeTap(adress);
  }

  async removeTap(address:CustomerAddress)
  {
    this.isLoading = true;

    var result = await this.customerservice.deleteCustomerAdress(address);

    if(result)
    {
      var indx = this.adressList.findIndex(x => x.Location === address.Location);

      if(indx > -1)
        this.adressList.splice(indx, 1);
    }
    else
      this.showWarning();
    
    this.isLoading = false;
  }

  showWarning()
  {
      this.alertDialog.open(AlertDialogComponent, {
      height: 'fit-content',
      width: 'fit-content',
      data: 
      { 
        title:this.localeservice.instantTranslation("Dialogs.Alert.AddressRemovalError.Title"), 
        detail:this.localeservice.instantTranslation("Dialogs.Alert.AddressRemovalError.Detail"), 
        accept:this.localeservice.instantTranslation("Dialogs.Alert.AddressRemovalError.Accept") 
      }
    });
  }
}
